import { merge } from 'ts-deepmerge';
import { MaybeLoanID } from 'src/common/types';
import { ZHLPersonalizedNextStepState } from 'src/services/graphql/generated/graphql';
import { useGetHeroGraphicModuleDataQuery } from 'src/services/graphql/generated/graphql';
import { useUnauthorizedAccessGuard } from 'src/services/graphql/hooks/useUnauthorizedAccessGuard';
import { isUUID } from 'src/utils/validators/isUUID';
import { ServerSideModuleData } from 'src/experiences/MortgageDashboard/GetServerSideProps/utils/getServerSideModuleData';

export type HeroGraphicState = {
    status: ZHLPersonalizedNextStepState | null;
};

const isServerDataSufficient = (data: Pick<ServerSideModuleData, 'HeroGraphic'>) => {
    const { homeLoansDashboardByLoanId } = data.HeroGraphic;
    const { personalizedNextSteps } = homeLoansDashboardByLoanId ?? {};
    const { currentState } = personalizedNextSteps ?? {};
    return !!currentState;
};

export const useHeroGraphicState = ({
    loanID,
    serverFetchedData,
}: {
    loanID: MaybeLoanID;
    serverFetchedData: Pick<ServerSideModuleData, 'HeroGraphic'>;
}): HeroGraphicState => {
    const { HeroGraphic } = serverFetchedData;
    const isLoanIDInvalid = !isUUID(loanID);
    const { data, error } = useGetHeroGraphicModuleDataQuery({
        variables: {
            id: loanID as string,
        },
        skip: isLoanIDInvalid || isServerDataSufficient(serverFetchedData),
    });
    useUnauthorizedAccessGuard(error);

    const mergedData = merge(data ?? {}, HeroGraphic);
    const { homeLoansDashboardByLoanId } = mergedData;
    const { personalizedNextSteps } = homeLoansDashboardByLoanId ?? {};
    const { currentState: status = null } = personalizedNextSteps ?? {};
    return {
        status,
    };
};
